import React from 'react';
import * as styles from './PageTitle.module.scss';

interface PageTitleProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
}

const PageTitle = ({ title, subtitle }: PageTitleProps) => (
  <div className={styles.title}>
    {typeof title === 'string' ? <h1>{title}</h1> : title}
    {!!subtitle && <div className={styles.subtitle}>{subtitle}</div>}
  </div>
);

export default PageTitle;
